import type { TeamEventRecord } from '../types';

type ConfirmableEvent = Pick<TeamEventRecord, 'id' | 'event_type' | 'event_date' | 'start_time' | 'timezone' | 'facility_id' | 'location_text' | 'status'>;

export function isConfirmableTeamEvent(event: Pick<TeamEventRecord, 'event_type' | 'status'>): boolean {
  return event.event_type !== 'Match' && ['Practice', 'Social', 'Meeting', 'Other'].includes(event.event_type)
    && ['Scheduled', 'Rescheduled'].includes(event.status);
}

// A confirmation applies only to the scheduling details the captain reviewed.
// Changing those details produces a new reminder without invalidating unrelated edits.
export function teamEventConfirmationKey(event: ConfirmableEvent): string {
  const details = [event.event_date, event.start_time, event.timezone, event.facility_id, event.location_text?.trim(), event.status]
    .map((value) => value || '').join('\u001f');
  let hash = 2166136261;
  for (let index = 0; index < details.length; index += 1) {
    hash = Math.imul(hash ^ details.charCodeAt(index), 16777619);
  }
  return `team_event_details_confirmation:${event.id}:${(hash >>> 0).toString(16)}`;
}
